module.exports = __webpack_public_path__ + "img/cortafuegos.cfa1f8d1.png";